module.exports = __webpack_public_path__ + "static/media/camera-photo-photography-svgrepo-com.aa66a4e7.svg";